import type { MouseEventHandler } from 'react';

import styles from './BaseNav.module.css';

import { Chevron, Close } from '../../../icons';
import { ButtonBase } from '../../ButtonBase';

export interface BaseNavProps {
  /** Toggle the navigation and displays a "close" button. */
  onCloseClick?: MouseEventHandler<HTMLButtonElement>;
  /** Toggle the navigation and displays a "back" button. */
  onBackClick?: MouseEventHandler<HTMLButtonElement>;
}

export function BaseNav(props: BaseNavProps) {
  if (!props.onBackClick && !props.onCloseClick) {
    return <></>;
  }
  return (
    <nav className={styles.root}>
      {props.onBackClick ? (
        <ButtonBase onClick={props.onBackClick} aria-label="Go Back">
          <Chevron orientation="left" height={36} />
        </ButtonBase>
      ) : (
        <span />
      )}
      {props.onCloseClick ? (
        <ButtonBase onClick={props.onCloseClick} aria-label="Close">
          <Close aria-hidden height={36} />
        </ButtonBase>
      ) : (
        <span />
      )}
    </nav>
  );
}
